// ============================================================================
// LEFTIST HEAP - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'leftist-heap',
  name: 'Leftist Heap',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A priority queue implemented as a variant of a binary heap. Maintains the leftist property (the left subtree is never smaller than the right subtree) to enable efficient merge operations in O(log N) time.'
};
